const layout = () => import("../../external/layout.vue");
const recovery = () => import("./recovery.vue");

const recoveryRoutes = {
  path: "/recovery",
  component: layout,
  children: [
    {
      path: "",
      name: "recovery",
      component: recovery,
    },
  ],
};

export default recoveryRoutes;
